var map = {
	"./activity/Store.js": 8097,
	"./benefit/Store.js": 8649,
	"./forget/Store.js": 5473,
	"./goods/Store.js": 1468,
	"./login/Store.js": 2699,
	"./main/Store.js": 213,
	"./my/Store.js": 6002,
	"./profile/Store.js": 9423,
	"./register/Store.js": 4397,
	"./shop/Store.js": 7476,
	"./trade/Store.js": 4692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4774;